import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { Clipboard } from '@angular/cdk/clipboard';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import { ONLINE_PAYMENT_LIMIT as _ONLINE_PAYMENT_LIMIT } from '@teem/constants/invoice';
import { environment } from '@teem/environments/environment';
import { Invoice } from '@teem/models/invoice';
import { messages as i18n } from '@teem/constants/messages';
import Swal from 'sweetalert2';
import * as COUNTRIES from '@teem/constants/country';

declare var $;

@Component({
  selector: 'view-invoice',
  templateUrl: './view-invoice.component.html',
  styleUrls: ['./view-invoice.scss']
})
export class ViewInvoiceComponent implements OnInit {
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() changeTab: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onView: EventEmitter<any> = new EventEmitter();
  @Output() doAction: EventEmitter<any> = new EventEmitter();
  @Output() payIncash: EventEmitter<any> = new EventEmitter();
  @Output() recordPayment: EventEmitter<any> = new EventEmitter();
  @Output() refundPayment: EventEmitter<any> = new EventEmitter();
  @Input() invoiceDetail: Invoice;
  @Input() isPaymentTab;
  basicInfo: any;
  paymentOptions: paymentOptions = {
    credit_card: false,
    credit_card_tap: false,
    credit_card_myfatoorah: false,
    stc_pay: false,
    bank_transfer: false,
    cash: false
  }
  allowToPayment: boolean = false;
  activeTab: boolean = true;
  onlinePaymentLimit = _ONLINE_PAYMENT_LIMIT;
  invResponse: any = null;
  locale: string = 'en';
  COUNTRIES: any = COUNTRIES;

  constructor(
    private elRef: ElementRef,
    private clipboard: Clipboard,
    private router: Router,
    private sharedDataService: SharedDataService) {
  }

  ngOnInit() {
    this.basicInfo = (window as any).userInfo;
    this.locale = (window as any).LOCALE;
    let node = this.elRef.nativeElement.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
    node.parentElement.classList.add("simplified-invoice");
    node.parentElement.classList.add("simplified-invoice--shadow");
    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.basicInfo = data.userInfo;
      }
    })

    if(this.invoiceDetail.uuid && (this.basicInfo.accept_credit_card && (this.basicInfo.active_invoice_subscription))) {
      this.invResponse = { 'url' : `${environment.baseUrl}/tap/invoice/${this.invoiceDetail.uuid}`};
    }

  }

  get prefTextColor() {
    return `${this.basicInfo.preference.text_color} !important;`;
  }

  // new update

  newDeliverableCost(deliverableValues: any) {
    let value = deliverableValues.quantity * deliverableValues.rate;
    if (!isNaN(value)) {
      return value;
    }
    return 0;
  }

  get newDeliverableTax() {
    const invoiceFormValues = this.invoiceDetail;
    let taxPercent = this.invoiceDetail.tax_percent / 100;
    let taxFinalAmount = 0;
    if (taxPercent) {
      if (invoiceFormValues.tax_type == 1) {
        taxFinalAmount = (this.newInvoiceOriginalAmount * invoiceFormValues.tax_percent / 100);
      } else if (invoiceFormValues.tax_type == 2) {
        taxFinalAmount = (((this.newInvoiceOriginalAmount) / (1 + invoiceFormValues.tax_percent / 100)) * (invoiceFormValues.tax_percent / 100));
      }
    }
    return taxFinalAmount;
  }

  get newSubTotalDeliverableCost(){
    let items = this.invoiceDetail.items ? this.invoiceDetail.items : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.newDeliverableCost(b), 0);
    }
    return 0;
  }

  get newInvoiceDiscountAmount() {
    let discountAmount = this.invoiceDetail.discount;
    let discountType = this.invoiceDetail.discount_type;
    if (discountAmount > 0) {
      if (discountType != 'percentage') {
        return discountAmount;
      }
      return (((this.newSubTotalDeliverableCost) / (100) * (discountAmount)));
    } else {
      return this.invoiceDetail?.discounted_amount;
    }
    return 0;
  }

  get newInvoiceDeliveryFeeAmount() {    
    if (this.invoiceDetail.delivery_fee > 0) {
      return this.invoiceDetail.delivery_fee;
    }
    return 0;
  }

  get newInvoiceOriginalAmount() {
    return (this.newSubTotalDeliverableCost - this.newInvoiceDiscountAmount);
  }

  get newTaxAmount() {
    let items = this.invoiceDetail.items ? this.invoiceDetail.items : [];
    if (items && items.length > 0) {
      // return (items.reduce((a, b) => a + this.deliverableTaxWithDiscountAmount(b), 0)).toFixed(2);
      let discountType = this.invoiceDetail.discount_type;
      if (discountType == 'percentage') {
        return (items.reduce((a, b) => a + this.deliverableTaxWithDiscountAmount(b), 0)).toFixed(2);
      }
      let itemsTotal = (items.reduce((a, b) => a + this.newDeliverableCost(b), 0)).toFixed(2);
      return this.deliverableTaxWithDiscountByAmount(itemsTotal);
    }
    return 0;
  }

  // new update end


  deliverableTaxWithDiscountAmount(deliverable: any) {
    let itemTotal = deliverable.quantity * deliverable.rate;
    let discountAmount = this.invoiceDetail.discount;
    let discountType = this.invoiceDetail.discount_type;
    if (discountAmount > 0) {
      if (discountType == 'percentage') {
        discountAmount = ((itemTotal / (100) * (discountAmount)));
      }
    } else {
      discountAmount = 0;
    }
    
    let value = itemTotal - discountAmount;
    if (this.invoiceDetail.tax_type == 2) {
      return deliverable.is_taxable ? ((value / (1 + this.invoiceDetail.tax_percent / 100)) * (this.invoiceDetail.tax_percent / 100)) : 0;
    } else if (this.invoiceDetail.tax_type == 3) {
      return 0;
    }
    return deliverable.is_taxable ? (value * this.invoiceDetail.tax_percent / 100) : 0;
  }

  deliverableTaxWithDiscountByAmount(itemTotal: any) {
    let discountAmount = this.invoiceDetail.discount;
    let discountType = this.invoiceDetail.discount_type;
    if (discountAmount > 0) {
      if (discountType == 'percentage') {
        discountAmount = ((itemTotal / (100) * (discountAmount)));
      }
    } else {
      discountAmount = 0;
    }
    
    let value = itemTotal - discountAmount;
    if (this.invoiceDetail.tax_type == 2) {
      return (value / (1 + this.invoiceDetail.tax_percent / 100)) * (this.invoiceDetail.tax_percent / 100);
    } else if (this.invoiceDetail.tax_type == 3) {
      return 0;
    }
    return (value * this.invoiceDetail.tax_percent / 100);
  }
  
  get taxAmount() {
    let taxPercent = this.invoiceDetail.tax_percent / 100;
    if (taxPercent) {
      let items = this.invoiceDetail.items ? this.invoiceDetail.items : [];
      if (items && items.length > 0) {
        return (items.reduce((a, b) => a + this.deliverableTax(b), 0)).toFixed(2);
      }
    }
    return 0;
  }

  getItemSubTotal(deliverable) {
    const invoiceFormValues = this.invoiceDetail;
    if (invoiceFormValues.tax_type == 2) {
      return ((deliverable.quantity * deliverable.rate)) / (1 + (invoiceFormValues.tax_percent / 100));
    } else {
      return deliverable.quantity * deliverable.rate;
    }
  }

  deliverableTax(deliverable: any) {
    if (this.invoiceDetail.tax_type == 2) {
      return deliverable.is_taxable ? (((deliverable.quantity * deliverable.rate) / (1 + this.invoiceDetail.tax_percent / 100)) * (this.invoiceDetail.tax_percent / 100)) : 0;
    } else if (this.invoiceDetail.tax_type == 3) {
      return 0;
    }
    return deliverable.is_taxable ? (deliverable.quantity * deliverable.rate * this.invoiceDetail.tax_percent / 100) : 0;

    // let value = deliverable.quantity * deliverable.rate;
    // console.log('valuesdfsfsdf')
    // console.log(value)
    // if (this.invoiceDetail.tax_type == 2) {
    //   if ((this.invoiceDetail.tax_percent && deliverable.is_taxable)) {
    //     return ((value / (1 + this.invoiceDetail.tax_percent / 100)) * (this.invoiceDetail.tax_percent / 100))
    //   }
    //   return 0;
    // } else if (this.invoiceDetail.tax_type == 3) {
    //   return 0;
    // }
    // return (this.invoiceDetail.tax_percent && deliverable.is_taxable) ? (value * this.invoiceDetail.tax_percent / 100) : 0;
  }

  deliverableCost(deliverable: any) {
    let value = deliverable.quantity * deliverable.rate;
    const invoiceFormValues = this.invoiceDetail;
    if (!isNaN(value)) {
      if (invoiceFormValues.include_tax && invoiceFormValues.tax_percent && deliverable.is_taxable) {
        if (invoiceFormValues.tax_type == 2 || invoiceFormValues.tax_type == 3) {
          value = value;// + (value / (1 + (invoiceFormValues.tax_percent / 100)));
        } else {
          value = value + value * invoiceFormValues.tax_percent / 100;
        }
      }
      return value;
    }
    return 0;

    // let value = deliverable.quantity * deliverable.rate + this.deliverableTax(deliverable);

    // if (!isNaN(value)) {
    //   return value;
    // }
    // return 0;
  }

  saveAsPdf() {
    if (this.basicInfo.accept_credit_card && this.basicInfo.is_contract_sign && this.invoiceDetail.due_amount >= this.onlinePaymentLimit) {
      Swal.fire({
        text: i18n.invoice.credit_card_payments_will_be_hidden_as_a_payment_method_if_your_invoice_total_exceeds,
        icon: 'warning',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: i18n.ok,
      }).then(result => {
        if (result.value) {
          (window as any).open(`${environment.baseUrl}/download-invoice/${this.invoiceDetail.uuid}/pdf?lang=${(window as any).LOCALE}`, '_blank');
        }
      })
    } else {
      (window as any).open(`${environment.baseUrl}/download-invoice/${this.invoiceDetail.uuid}/pdf?lang=${(window as any).LOCALE}`, '_blank');
    }

    

  }

  emailInvoice() {
    if (this.basicInfo.accept_credit_card && this.basicInfo.is_contract_sign && this.invoiceDetail.due_amount >= this.onlinePaymentLimit) {
      Swal.fire({
        text: i18n.invoice.credit_card_payments_will_be_hidden_as_a_payment_method_if_your_invoice_total_exceeds,
        icon: 'warning',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: i18n.ok,
      }).then(result => {
        if (result.value) {
          this.doAction.emit({ action: INVOICE_ACTIONS.EMAIL, invoice: this.invoiceDetail });
        }
      })
    } else {
      this.doAction.emit({ action: INVOICE_ACTIONS.EMAIL, invoice: this.invoiceDetail });
    }

  }

  deleteInvoice() {
    this.onDelete.emit(this.invoiceDetail);
  }

  viewInvoice() {
    this.onView.emit([this.invoiceDetail?.parent_invoice.uuid]);
  }

  editInvoice() {
    let node = this.elRef.nativeElement.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
    node.parentElement.classList.remove("simplified-invoice");
    node.parentElement.classList.remove("simplified-invoice--shadow");
    this.onEdit.emit(this.invoiceDetail);
  }

  recordNewPayment() {
    this.recordPayment.emit(this.invoiceDetail);
  }

  updateStatus() {
    this.refundPayment.emit(this.invoiceDetail);
  }

  whatsappInvoice() {
    if (this.basicInfo.accept_credit_card && this.basicInfo.is_contract_sign && this.invoiceDetail.due_amount >= this.onlinePaymentLimit) {
      Swal.fire({
        text: i18n.invoice.credit_card_payments_will_be_hidden_as_a_payment_method_if_your_invoice_total_exceeds,
        icon: 'warning',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: i18n.ok,
      }).then(result => {
        if (result.value) {
          this.doAction.emit({ action: INVOICE_ACTIONS.WHATSAPP, invoice: this.invoiceDetail });
        }
      })
    } else {
      this.doAction.emit({ action: INVOICE_ACTIONS.WHATSAPP, invoice: this.invoiceDetail });
    }

  }

  copyShareLink() {
    try {
      this.clipboard.copy(this.invoiceDetail.share_link);

      Swal.fire(i18n.done, i18n.invoice.invoice_copied_to_clipboard, 'success');
    } catch (err) {
      console.error(err);
    }
  }

  payInvoice() {
    this.doAction.emit({ action: INVOICE_ACTIONS.PAY, invoice: this.invoiceDetail });
  }

  payInCashInvoice(key) {
    this.payIncash.emit({ details: this.invoiceDetail, payment_method: key });
  }

  isToggle(event, action) {
    event.preventDefault();
    Object.keys(this.paymentOptions).forEach(key => {
      this.paymentOptions[key] = (key == action && event.target.checked) ? true : false;
      if (event.target.checked) {
        this.allowToPayment = true
        if (key == action) {
          console.log(key)
        }
      } else {
        this.allowToPayment = false
      }
    });
  }

  paymentMethod(key) {
    switch (key) {
      case 'hala':
        this.continueToPayment()
        break;
      case 'bank_transfer':
      case 'cash':
        this.payInCashInvoice(key)
        break;
    }
  }
  onTabChange(flag) {
    if (flag) {
      this.activeTab = true
    } else {
      this.activeTab = false
    }
  }

  continueToPayment() {
    alert('allowToPayment' + this.allowToPayment)
  }

  payViaHyperpay(invoice: any) {
    if (invoice.due_amount < 5) {
      Swal.fire({
        text: i18n.invoice.invoice_amount_reached,
        icon: 'info',
      });
    } else {
      Swal.fire({
        text: i18n.invoice.you_cannot_redirect_to_payment_gateway_on_preview_mode,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: i18n.yes,
        cancelButtonText: i18n.no_cancel_it
      }).then(result => {
        if (result.value) {
          window.location.href = `${environment.baseUrl}/hyperpay/invoice/${invoice.uuid}`;
        }
      })
    }
  }

  payViaTap(invoice: any) {
    if (invoice.due_amount < 1) {
      Swal.fire({
        text: i18n.invoice.tap_invoice_amount_reached,
        icon: 'info',
      });
    } else {
      Swal.fire({
        text: i18n.invoice.you_cannot_redirect_to_payment_gateway_on_preview_mode,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: i18n.yes,
        cancelButtonText: i18n.no_cancel_it
      }).then(result => {
        if (result.value) {
          window.location.href = `${environment.baseUrl}/tap/invoice/${invoice.uuid}`;
        }
      })
    }
  }

  payViaMyfatoorah(invoice: any) {
    if (invoice.due_amount < 1) {
      Swal.fire({
        text: i18n.invoice.tap_invoice_amount_reached,
        icon: 'info',
      });
    } else {
      Swal.fire({
        text: i18n.invoice.you_cannot_redirect_to_payment_gateway_on_preview_mode,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: i18n.yes,
        cancelButtonText: i18n.no_cancel_it
      }).then(result => {
        if (result.value) {
          window.location.href = `${environment.baseUrl}/myfatoorah/invoice/${invoice.uuid}`;
        }
      })
    }
  }

  invoiceStatus(value) {
    let status = i18n[value] ? i18n[value] : i18n.pending;

    return `${status}`;
  }

  isTaxPresent(): boolean {

    this.invoiceDetail.tax_percent == null ? this.invoiceDetail.tax_percent = 0 : this.invoiceDetail.tax_percent;

    return this.invoiceDetail.tax_percent == 0 ? false : true;

  }

  backToInvoice() {
    if (this.isPaymentTab && this.isPaymentTab == 'payments-tab') {
      this.changeTab.emit('received-payments');
    } else {
      this.changeTab.emit('all-invoices');
    }
  }

  pushToFatoora() {
    Swal.fire({
      title: i18n.are_you_sure,
      text: "You want to push invoice on Fatoora",
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText:
        i18n.yes,
      cancelButtonText:
        i18n.no_cancel_it
    }).then(result => {
      if (result.value) {
        this.doAction.emit({ action: INVOICE_ACTIONS.PUSH_FATOORA, invoice: this.invoiceDetail });
      }
    });
  }

  // validateZatcaInvoice() {
  //   Swal.fire({
  //     title: i18n.are_you_sure,
  //     text: "You want to validate invoice on Fatoora",
  //     icon: 'info',
  //     showCloseButton: true,
  //     showCancelButton: true,
  //     focusConfirm: false,
  //     confirmButtonText:
  //       i18n.yes,
  //     cancelButtonText:
  //       i18n.no_cancel_it
  //   }).then(result => {
  //     if (result.value) {
  //       this.doAction.emit({ action: INVOICE_ACTIONS.VALIDATE_ZATCA_INVOICE, invoice: this.invoiceDetail });
  //     }
  //   });
  // }

  checkReceivedPayments() {
    if (this.router.url !== '/payments') {
      this.router.navigate(['/payments']);
    } else {
      this.changeTab.emit('received-payments');
    }
  }

  toggleInvoiceResendOptions() {
    $("#invoices-resend-wrapper").fadeToggle(100);
  };

  setInvoiceWidth(condition) {
    $("#left-section-pdf").hide();
    $("#left-section-invoice").hide();
    $(".invoice-screen-type").removeClass("active");
    $(".page-size").removeClass('page-size--mobile');
    $(".page-size").removeClass('page-size--pdf');
    $(".prev-invoice__bottomInfo").removeClass("prev-invoice__bottomInfo--mobile");
    $("body").removeClass("mobile--size");
    $("body").removeClass("pdf--size");
    $("body").removeClass("web--size");

    if (condition == "mobile") {
      $(".ist-1").addClass("active");
      $(".page-size").addClass('page-size--mobile');
      $(".prev-invoice__bottomInfo").addClass('prev-invoice__bottomInfo--mobile');
      $("body").addClass("mobile--size");
      $("#left-section-invoice").show();
    } else if (condition == "web") {
      $(".ist-3").addClass("active");
      $("body").addClass("web--size");
      $("#left-section-invoice").show();
    } else if (condition == "pdf") {
      $("#left-section-pdf").hide();
      $(".page-size").addClass('page-size--pdf');
      var invoice, node = document.getElementsByClassName("prev-invoice__leftSection")[0];
      $(".prev-invoice__editsave").toggle(); 

      $("body").addClass("pdf--size");
      $("#left-section-pdf").show(); 
      $(".ist-2").addClass("active");
    }
  }

}



export interface paymentOptions {
  credit_card: boolean,
  credit_card_tap: boolean,
  credit_card_myfatoorah: boolean,
  stc_pay: boolean,
  bank_transfer: boolean,
  cash: boolean
}
